/*eslint no-undef: "off"*/
/*eslint eqeqeq: "off"*/


try{
    importScripts('utm.min.js');
  }
  catch(e){}
  
  // ---------------------------------------------------------
  // Spatial functions
  
  const Relationship = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
  }
  
  class GeomUtils {
  
    static coordinateRelationship(extent, x, y) {
      var minX = extent[0];
      var minY = extent[1];
      var maxX = extent[2];
      var maxY = extent[3];
  
      var relationship = Relationship.UNKNOWN;
  
      if (x < minX) {
        relationship = relationship | Relationship.LEFT;
      } else if (x > maxX) {
        relationship = relationship | Relationship.RIGHT;
      }
  
      if (y < minY) {
        relationship = relationship | Relationship.BELOW;
      } else if (y > maxY) {
        relationship = relationship | Relationship.ABOVE;
      }
  
      if (relationship === Relationship.UNKNOWN) {
        relationship = Relationship.INTERSECTING;
      }
  
      return relationship;
    }
  
    static intersectsSegment(extent, x1, y1, x2, y2) {
  
      var startRel = this.coordinateRelationship(extent, x1, y1);
      if (startRel === Relationship.INTERSECTING)
        return true;
  
      var endRel = this.coordinateRelationship(extent, x2, y2);
      if (endRel === Relationship.INTERSECTING)
        return true;
  
  
      var minX = extent[0];
      var minY = extent[1];
      var maxX = extent[2];
      var maxY = extent[3];
  
      var slope = (y2 - y1) / (x2 - x1);
      var x, y;
  
      if (!!(endRel & Relationship.ABOVE) &&
        !(startRel & Relationship.ABOVE)) {
        // potentially intersects top
        x = x2 - ((y2 - maxY) / slope);
  
        if (x >= minX && x <= maxX)
          return true;
      }
  
      if (!!(endRel & Relationship.RIGHT) &&
        !(startRel & Relationship.RIGHT)) {
        // potentially intersects right
        y = y2 - ((x2 - maxX) * slope);
  
        if (y >= minY && y <= maxY)
          return true;
      }
  
      if (!!(endRel & Relationship.BELOW) &&
        !(startRel & Relationship.BELOW)) {
        // potentially intersects bottom
        x = x2 - ((y2 - minY) / slope);
  
        if (x >= minX && x <= maxX)
          return true;
      }
  
      if (!!(endRel & Relationship.LEFT) &&
        !(startRel & Relationship.LEFT)) {
        // potentially intersects left
        y = y2 - ((x2 - minX) * slope);
  
        if (y >= minY && y <= maxY)
          return true;
      }
  
  
      return false;
    }
  
    static linearRingIsClockwise(coordinates) {
      var edge = 0;
      var end = coordinates.length;
  
      var x1 = coordinates[end - 2];
      var y1 = coordinates[end - 2 + 1];
  
      for (var i = 0; i < end; i += 2) {
        var x2 = coordinates[i];
        var y2 = coordinates[i + 1];
  
        edge += (x2 - x1) * (y2 + y1);
  
        x1 = x2;
        y1 = y2;
      }
  
      return edge > 0;
    }
  
    static extentFromCoordinates(coordinates) {
      var minX = coordinates[0];
      var minY = coordinates[1];
      var maxX = coordinates[0];
      var maxY = coordinates[1];
  
      var end = coordinates.length;
      for (var i = 2; i < end; i += 2) {
        if (coordinates[i] < minX) {
          minX = coordinates[i];
        }
        else if (coordinates[i] > maxX) {
          maxX = coordinates[i];
        }
  
        if (coordinates[i + 1] < minY) {
          minY = coordinates[i + 1];
        }
        else if (coordinates[i + 1] > maxY) {
          maxY = coordinates[i + 1];
        }
      }
  
      return [minX, minY, maxX, maxY];
    }
  
    static intersectsExtent(extent1, extent2) {
      return extent1[0] <= extent2[2] &&
        extent1[2] >= extent2[0] &&
        extent1[1] <= extent2[3] &&
        extent1[3] >= extent2[1];
    }
  
    static intersectsLinearRing(extent, coordinates) {
  
      // intersect border
      if (this.intersectsLineString(extent, coordinates)) {
        return true;
      }
  
      // contains left bottom
      if (this.linearRingContainsXY(coordinates, extent[0], extent[1])) {
        return true;
      }
  
      // contains left top
      if (this.linearRingContainsXY(coordinates, extent[0], extent[3])) {
        return true;
      }
  
      // contains right bottom
      if (this.linearRingContainsXY(coordinates, extent[2], extent[1])) {
        return true;
      }
  
      // contains right top
      if (this.linearRingContainsXY(coordinates, extent[2], extent[3])) {
        return true;
      }
  
      return false;
    }
  
    static intersectsLineString(extent, coordinates) {
      var coordinatesExtent = this.extentFromCoordinates(coordinates);
  
      if (!this.intersectsExtent(extent, coordinatesExtent)) {
        return false;
      }
  
      if (coordinatesExtent[0] >= extent[0] &&
        coordinatesExtent[2] <= extent[2]) {
        return true;
      }
  
      if (coordinatesExtent[1] >= extent[1] &&
        coordinatesExtent[3] <= extent[3]) {
        return true;
      }
  
      var qtd = coordinates.length;
      for (var i = 2; i < qtd; i += 2) {
        if (this.intersectsSegment(extent, coordinates[i - 2], coordinates[i - 1], coordinates[i], coordinates[i + 1]))
          return true;
      }
  
      return false;
    }
  
    static intersectedLineStringSegmentIdx(extent, coordinates) {
      var coordinatesExtent = this.extentFromCoordinates(coordinates);
  
      if (!this.intersectsExtent(extent, coordinatesExtent)) {
        return -1;
      }
      
      var qtd = coordinates.length;
      for (var i = 2; i < qtd; i += 2) {
        if (this.intersectsSegment(extent, coordinates[i - 2], coordinates[i - 1], coordinates[i], coordinates[i + 1]))
          return i - 2;
      }
  
      return -1;
    }
  
    static linearRingContainsXY(coordinates, x, y) {
      // http://geomalgorithms.com/a03-_inclusion.html
      // Copyright 2000 softSurfer, 2012 Dan Sunday
      // This code may be freely used and modified for any purpose
      // providing that this copyright notice is included with it.
      // SoftSurfer makes no warranty for this code, and cannot be held
      // liable for any real or imagined damage resulting from its use.
      // Users of this code must verify correctness for their application.
  
      var wn = 0;
      var end = coordinates.length;
  
      var x1 = coordinates[end - 2];
      var y1 = coordinates[end - 1];
  
      for (var i = 0; i < end; i += 2) {
        var x2 = coordinates[i];
        var y2 = coordinates[i + 1];
        if (y1 <= y) {
          if (y2 > y && ((x2 - x1) * (y - y1)) - ((x - x1) * (y2 - y1)) > 0) {
            wn++;
          }
        } else if (y2 <= y && ((x2 - x1) * (y - y1)) - ((x - x1) * (y2 - y1)) < 0) {
          wn--;
        }
        x1 = x2;
        y1 = y2;
      }
  
      return wn !== 0;
    }
  
    static linearRingContainsExtent(coordinates, extent) {
  
      // dont contains left bottom
      if (!this.linearRingContainsXY(coordinates, extent[0], extent[1])) {
        return false;
      }
  
      // dont contains left top
      if (!this.linearRingContainsXY(coordinates, extent[0], extent[3])) {
        return false;
      }
  
      // dont contains right bottom
      if (!this.linearRingContainsXY(coordinates, extent[2], extent[1])) {
        return false;
      }
  
      // dont contains right top
      if (!this.linearRingContainsXY(coordinates, extent[2], extent[3])) {
        return false;
      }
  
      // intersect border
      if (this.intersectsLineString(extent, coordinates)) {
        return false;
      }
  
      return true;
    }
  
    static extractLargestPolygon(polygonList) {
      if (polygonList.length === 1)
        return polygonList[0];
  
      var largestArea = -1;
      var largestIdx = -1;
      
      polygonList.forEach((rings, idx) => {
        var newArea = this.measureArea(rings[0]);
  
        if (newArea > largestArea) {
          largestArea = newArea;
          largestIdx = idx;
        }
  
      });
  
      return polygonList[largestIdx];
    }
  
    static extractPolygonsFromRings(rings) {
      var polygons = [];
      
      var outerRing = rings[0];
      var polygonRings = [outerRing];
  
      polygons.push(polygonRings);
  
      for (var i = 1, qtd = rings.length; i < qtd; i++) {
        var intersects = this.linearRingContainsXY(outerRing, rings[i][0], rings[i][1]);
  
        if (intersects) {
          //check holes
  
          for (var j = 1, ringsQtd = polygonRings.length; j < ringsQtd; j++) {
            if (this.linearRingContainsXY(polygonRings[j], rings[i][0], rings[i][1])) {
              intersects = false;
              break;
            }
          }
        }
        
        if (intersects) {
          //hole (inner ring)
          polygonRings.push(rings[i]);
        }
        else {
          //new element
          outerRing = rings[i];
          polygonRings = [outerRing];
  
          polygons.push(polygonRings);
        }
  
      }
  
      return polygons;
    }
  
  
  
  
  
    static toWebMercator(geographicOrdinates, updateCurrentArray = false) {
      var ordinates = updateCurrentArray ? geographicOrdinates : geographicOrdinates.slice();
  
      for (var i = 0, qtd = ordinates.length; i < qtd; i += 2) {
        var x = ordinates[i] * 20037508.342789244 / 180;
        var y = Math.log(Math.tan((90 + ordinates[i + 1]) * Math.PI / 360)) / (Math.PI / 180);
        y = y * 20037508.342789244 / 180;
    
        ordinates[i] = x;
        ordinates[i + 1] = y;
      }
  
      return ordinates;
    }
  
    static fromWebMercator(projectedOrdinates, updateCurrentArray = false) {
      var ordinates = updateCurrentArray ? projectedOrdinates : projectedOrdinates.slice();
  
      for (var i = 0, qtd = ordinates.length; i < qtd; i += 2) {
        ordinates[i] = (ordinates[i] / 20037508.342789244) * 180;
        ordinates[i + 1] = 180 / Math.PI * (2 * Math.atan(Math.exp(ordinates[i + 1] / 20037508.342789244 * Math.PI)) - Math.PI / 2);
  
        while (ordinates[i] > 180)
          ordinates[i] -= 360;
  
        while (ordinates[i] < -180)
          ordinates[i] += 360;
      }
  
      return ordinates;
    }
  
    static getUTMZone(lon) {
      return UTM.getUTMZone(lon);
    }
  
    static isSouthHemisphere(lat) {
      return UTM.isSouthHemisphere(lat);
    }  
  
    static toUTM(geographicOrdinates, datum = 'WGS84', zone = null, south = null, updateCurrentArray = false) {
      var ordinates = updateCurrentArray ? geographicOrdinates : geographicOrdinates.slice();
  
      if (zone == null) {
        zone = UTM.getUTMZone(ordinates[0]);
        south= UTM.isSouthHemisphere(ordinates[1]);
      }
  
      //cached instaces for utm converters
      var key = datum +'_'+ zone + (south ? 'S' : 'N');
  
      if (!this._utmInstances) {
        this._utmInstances = {
          [key] : new UTM({ datum, zone, south })
        }
      }
      else if (!this._utmInstances[key]){
        this._utmInstances[key] = new UTM({ datum, zone, south });
      }
  
      var utm = this._utmInstances[key];
  
      for (var i = 0, qtd = ordinates.length; i < qtd; i += 2) {
        var coord = utm.toProjected(ordinates[i], ordinates[i + 1]);
  
        ordinates[i] = coord[0];
        ordinates[i + 1] = coord[1];
      }
  
      return ordinates;
    }
  
    static fromUTM(projectedOrdinates, datum, zone, south, updateCurrentArray = false) {
      var ordinates = updateCurrentArray ? projectedOrdinates : projectedOrdinates.slice();
  
      var utm = new UTM({ datum, zone, south });
  
      for (var i = 0, qtd = ordinates.length; i < qtd; i += 2) {
        var coord = utm.toGeographic(ordinates[i], ordinates[i + 1]);
  
        ordinates[i] = coord[0];
        ordinates[i + 1] = coord[1];
      }
  
      return ordinates;
    }

    static limitWorldCoordinates(geographicOrdinates, updateCurrentArray = false) {
      var ordinates = updateCurrentArray ? geographicOrdinates : geographicOrdinates.slice();
  
      var lon;
      var lat;
      for (var i = 0, qtd = ordinates.length; i < qtd; i += 2) {
        lon = ordinates[i];
        lat = ordinates[i + 1];
  
        if (Math.abs(lon) >= 180) {
          lon = Math.sign(lon) * ((Math.abs(lon + 180)) % 360) - 180;
          if (lon <= -180)
            lon += 360;
        }
  
        if (Math.abs(lat) >= 90) {
          lat = Math.sign(lat) * ((Math.abs(lat + 90)) % 180) - 90;
          if (lat <= -90)
            lat += 180;
        }
  
        ordinates[i] = lon;
        ordinates[i + 1] = lat;
      }
  
      return ordinates;
    }

    static round(value, precision, updateCurrentArray = false) {
      var c = Math.pow(10, precision);
  
      //for collection
      if (Array.isArray(value)){
        var values = updateCurrentArray ? value : value.slice();
  
        for (var i = 0, qtd = values.length; i < qtd; i ++) {
          values[i] = Math.round(values[i]*c)/c;
        }
  
        return value;
      }
  
      return Math.round(value*c)/c;
    }
  
  
    static measurePointDistance(x1, y1, x2, y2) {
      return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    }
  
  
    static measureArea(projectedOrdinates) {
      var area = 0;
      var lastIdx = projectedOrdinates.length - 2;
  
      if (lastIdx > 0) {
        for (var i = 0; i < lastIdx; i += 2) {
          area += (projectedOrdinates[i] * projectedOrdinates[i + 3]) - (projectedOrdinates[i + 1] * projectedOrdinates[i + 2]);
        }
  
        if ((projectedOrdinates[lastIdx] != projectedOrdinates[0]) || (projectedOrdinates[lastIdx + 1] != projectedOrdinates[1])) {
          area += (projectedOrdinates[lastIdx] * projectedOrdinates[1]) - (projectedOrdinates[lastIdx + 1] * projectedOrdinates[0]);
        }
      }
  
      return (Math.abs(area) / 2);
    }
  
  
    static measureLength(projectedOrdinates) {
      var distance = 0;
  
      var lastPointIdx = projectedOrdinates.length - 2;
      for (var i = 0; i < lastPointIdx; i += 2) {
        distance += this.measurePointDistance(projectedOrdinates[i], projectedOrdinates[i + 1], projectedOrdinates[i + 2], projectedOrdinates[i + 3]);
      }
  
      return distance;
    }
  
  
    static measurePerimeter(projectedOrdinates) {
      var distance = 0;
  
      var lastPointIdx = projectedOrdinates.length - 2;
      for (var i = 0; i < lastPointIdx; i += 2) {
        distance += this.measurePointDistance(projectedOrdinates[i], projectedOrdinates[i + 1], projectedOrdinates[i + 2], projectedOrdinates[i + 3]);
      }
  
      if (lastPointIdx > 0)
              distance += this.measurePointDistance(projectedOrdinates[lastPointIdx], projectedOrdinates[lastPointIdx + 1], projectedOrdinates[0], projectedOrdinates[1]);
  
      return distance;
    }
  
  
  
  
  
  
  
  
  
    // ---------------------------------------------------------
    // Line functions
  
    static lineIntersectsExtent(data, extent) {
      // already validated extent
  
      if (data.minX >= extent[0] &&
        data.maxX <= extent[2]) {
        return true;
      }
  
      if (data.minY >= extent[1] &&
        data.maxY <= extent[3]) {
        return true;
      }
  
  
      var qtd = data.coord.length;
      for (var i = 2; i < qtd; i += 2) {
        if (this.intersectsSegment(extent, data.coord[i - 2], data.coord[i - 1], data.coord[i], data.coord[i + 1]))
          return true;
      }
  
      return false;
    }
  
  
  
    // ---------------------------------------------------------
    // Polygon functions
  
    static polygonIntersectsExtent(data, extent) {
      // already validated extent
  
      if (data.minX >= extent[0] &&
        data.maxX <= extent[2]) {
        return true;
      }
  
      if (data.minY >= extent[1] &&
        data.maxY <= extent[3]) {
        return true;
      }
  
      // check outer ring intersection
      if (!this.intersectsLinearRing(extent, data.coord[0])) {
        return false;
      }
  
      var qtd = data.coord.length;
      if (qtd > 1) {
  
        for (var i = 1; i < qtd; i++) {
          if (this.linearRingContainsExtent(data.coord[i], extent)) {
            return false;
          }
        }
  
      }
  
      return true;
    }
  
  }
  
  if (typeof global !== 'undefined') {
      global.GeomUtils = GeomUtils;
  }